import { NgClass } from "@angular/common";
import { Component, Input } from "@angular/core";

@Component({
  selector: "app-icon-down-arrow",
  imports: [NgClass],
  templateUrl: "./icon-down-arrow.component.html",
  styleUrl: "./icon-down-arrow.component.scss",
})
export class IconDownArrowComponent {
  @Input() active: boolean = false;
}
